import LockIcon from '@mui/icons-material/Lock';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export const CONFIDENTIAL_LABEL = 'Confidentiel';

// An amount or a cost the user may not read: the API sends it null.
export const ConfidentialValue = () => (
  <Stack
    aria-label={CONFIDENTIAL_LABEL}
    direction="row"
    spacing={1}
    sx={{ alignItems: 'center' }}
  >
    <LockIcon color="disabled" fontSize="small" />
    <Typography color="text.secondary" variant="body2">
      {CONFIDENTIAL_LABEL}
    </Typography>
  </Stack>
);
